import React, { Component, PropTypes } from 'react';
import styles from 'src/styles/AuthPopup.scss';
import vkIcon from 'src/imgs/vk-icon.svg';
import fbIcon from 'src/imgs/fb-icon.svg';
import okIcon from 'src/imgs/ok-icon.svg';
import twitterIcon from 'src/imgs/twitter-icon.svg';
import gplusIcon from 'src/imgs/gplus-icon.svg';
import InlineSVG from 'react-svg-inline';



export default class RegistrationPopupSocBtns extends Component {
  render() {
    return (
      <div className={styles.socBtnsContainer}>
        <InlineSVG
          className={styles.socBtn}
          svg={gplusIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={twitterIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={vkIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={fbIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={okIcon} />
      </div>
    );
  }
}



RegistrationPopupSocBtns.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/RegistrationPopupSocBtns.jsx
 **/